import { Controller } from "@hotwired/stimulus"

// Toggles a collapsible section and persists its open/closed state in
// sessionStorage keyed by idValue. The mappings turbo-frame re-renders on every
// autosave and rebuilds this element from scratch, so the server-rendered
// `open` default would otherwise win on each save; restoring from storage on
// connect() keeps a section the user collapsed collapsed (and vice-versa)
// across those re-renders.
export default class extends Controller {
  static targets = ["header", "body", "chevron"]
  static values = { id: String }

  connect() {
    const stored = sessionStorage.getItem(this.storageKey)
    if (stored !== null) this.apply(stored === "open")
    else this.reflect()
  }

  toggle(event) {
    event.preventDefault()
    this.apply(this.bodyTarget.hidden)
  }

  apply(open) {
    this.bodyTarget.hidden = !open
    sessionStorage.setItem(this.storageKey, open ? "open" : "closed")
    this.reflect()
  }

  reflect() {
    const open = !this.bodyTarget.hidden
    this.headerTarget.setAttribute("aria-expanded", open ? "true" : "false")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-90", open)
    }
  }

  get storageKey() {
    return `cup:disclosure:${this.idValue}`
  }
}
